import { render, staticRenderFns } from "./item_edit.vue?vue&type=template&id=25f49e1e&"
import script from "./item_edit.vue?vue&type=script&lang=ts&"
export * from "./item_edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports